import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {createSelector} from "reselect";

import {geoUtils} from '../utils/geo-utils';

/**
 * Component for drawing the states of on the national state map.
 *
 * This component is only responsible for drawing the color classified shapes of
 * the svg map, the borders and hovers are handled by other components.
 *
 * The color of each shape is determined by the data and the quartile of the state
 * using the geoUtils.createQuartileFillScale
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property data - array of location models to calculate the map shape color values
 * @property dict - dictionary of data keyed by the state fips
 * @property dimension - field in data objects that holds the quartile value for classification
 *
 * @example
 * return (
 *   <UsaStateShapes
 *     data={this.props.data}
 *     dict={this.props.dict}
 *     width={this.state.width}
 *     height={this.state.height}
 *     dimension={this.props.colorField}
 *   />
 * )
 */
export default class UsaStateShapes extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    data: PropTypes.array,
    dict: PropTypes.object,
    dimension: PropTypes.string
  }

  getWidth = (props) => props.width
  getHeight = (props) => props.height
  getData = (props) => props.data
  getDimension = (props) => props.dimension

  getPaths = createSelector(
    [this.getWidth, this.getHeight],
    (width, height) => geoUtils.getAlbersUsaStatePaths(width, height)
  )

  getScale = createSelector(
    [this.getData, this.getDimension],
    (data, dimension) => geoUtils.createQuartileFillScale(data, dimension)
  )

  render() {
    const paths = this.getPaths(this.props);
    const scale = this.getScale(this.props);

    const getValue = d => _.get(this.props.dict, [d.id], {});

    return (
      <g className="UsaStateShapes">
        {paths.map(d => (
          <path
            key={d.id}
            d={d.path}
            fill={scale(getValue(d))}
          />
        ))}
      </g>
    )
  }
}
